import { z } from 'zod';

import { calculateIvc } from './utils';

const intField = (label: string) =>
  z
    .number({
      required_error: `${label} is required`,
      invalid_type_error: `${label} must be a number`,
    })
    .int(`${label} must be a whole number`);

const requiredDateField = (label: string) =>
  z.date({
    required_error: `${label} is required`,
    invalid_type_error: `Please enter a valid ${label}`,
  });

export type StrippingProgress = {
  completed: number;
  total: number;
};

export const validation = z
  .object({
    hasFewMotileSperm: z.boolean(),
    hasNoMotileSperm: z.boolean(),
    hasPoorCytoplasmQuality: z.boolean(),
    hasTwoCellCleavage: z.boolean(),
    isFragile: z.boolean(),
    isHardToStrip: z.boolean(),
    ivfNumber: intField('IVF Number'),
    ivcNumber: intField('IVC Number'),
    ivcBroken: intField('Broken'),
    ivcDead: intField('Dead'),
    ivcExtra: intField('Extra'),
    ivcImmature: intField('Immature'),
    ivcMissing: intField('Missing'),
    ivcComment: z.string(),
    qcIncubator: z
      .string({
        required_error: 'Please select an incubator',
        invalid_type_error: 'Please select an incubator',
      })
      .min(1, 'Please select an incubator'),
    strippedAtDate: requiredDateField('IVC Date'),
    strippedAtTime: requiredDateField('IVC Time'),
    contaminationInFert: z.boolean(),
  })
  .refine(
    (row) => {
      const calcIvc = calculateIvc(row);
      return row.ivcNumber === calcIvc;
    },
    {
      message: 'IVC Number must match the calculated IVC total',
      path: ['ivcNumber'],
    },
  );
export type Values = z.TypeOf<typeof validation>;
